import { CartActionsUnion, CartActionTypes } from '../actions/cart.actions';
import { Order } from '@vestiaire/api-sdk-angular';

export interface State {
  order: Order | null;
  pending: boolean;
}

export const initialState: State = {
  order: null,
  pending: false
};

export function reducer(state = initialState, action: CartActionsUnion) {
  switch (action.type) {
    case CartActionTypes.LoadCart:
      return {
        ...state,
        pending: true
      };

    case CartActionTypes.LoadCartSuccess:
      return {
        ...state,
        order: action.payload.order,
        pending: false
      };

    case CartActionTypes.AddToCart:
    case CartActionTypes.RemoveFromCart:
      return {
        ...state,
        pending: true
      };

    case CartActionTypes.AddToCartSuccess:
    case CartActionTypes.AddToCartFailure:
    case CartActionTypes.RemoveFromCartSuccess:
    case CartActionTypes.RemoveFromCartFailure:
      return {
        ...state,
        pending: false
      };

    case CartActionTypes.LoadCartFailure:
      return initialState;

    default:
      return state;
  }
}

export const getOrder = (state: State) => state.order;
export const getPending = (state: State) => state.pending;
